(function () {
    const rules = window.APPAREL_RULES || {};
    const brandOptions = window.BRAND_OPTIONS || [];
    let isSyncing = false;
  
    const builders = document.querySelectorAll("[data-apparel-builder]");
  
    builders.forEach((builder) => {
      const templateSuffix = builder.dataset.templateSuffix;
  
      let mode = "adultonly";
      let activeRules = null;
  
      if (templateSuffix === "adultonly" || templateSuffix === "apparel") {
        mode = "adultonly";
        activeRules = rules["Adult"];
      } else if (templateSuffix === "allagesapparel") {
        mode = "allages";
        activeRules = rules;
      }
  
      if (!activeRules) {
        console.error("BCS Apparel Builder: No rules found for", templateSuffix);
        return;
      }
  
      builder.__BCS_MODE__ = mode;
      builder.__BCS_RULES__ = activeRules;
  
      initBuilder(builder);
    });
  
    function initBuilder(builder) {
      const COLOR_SWATCH_MAP = {
        "White": "#ffffff",
        "Off White": "#f7f5ef",
        "Natural": "#efe2c6",
        "Ice Gray": "#dddddd",
        "Sport Gray": "linear-gradient(135deg, #d8d8d8 0%, #b5b5b5 100%)",
        "Charcoal": "#4a4a4a",
        "Graphite Heather": "linear-gradient(135deg, #9d9d9d 0%, #6f6f6f 100%)",
        "Dark Heather": "linear-gradient(135deg, #6d6d6d 0%, #4f4f4f 100%)",
        "Heather Dark Grey": "linear-gradient(135deg, #7a7a7a 0%, #5e5e5e 100%)",
        "Black": "#111111",

        "Heather Oatmeal": "linear-gradient(135deg, #d9cfbd 0%, #b9ae97 100%)",
        "Cornsilk": "#f5efcf",
        "Daisy": "#f0d24a",
        "Gold": "#d0a92b",
        "Heather Orange": "linear-gradient(135deg, #e8a15d 0%, #c97d37 100%)",
        "Orange": "#ff7a00",
        "Fan Texas Orange": "#d95f02",
        "Light Pink": "#f7c8d3",
        "Azalea": "#f3a7ba",
        "Coral Silk": "#f2b6a0",

        "Heather Heliconia": "linear-gradient(135deg, #d887b5 0%, #b75a8d 100%)",
        "Heliconia": "#d94b8a",
        "Antique Heliconia": "linear-gradient(135deg, #c06b97 0%, #9d4d76 100%)",
        "Heather Maroon": "linear-gradient(135deg, #8b5a64 0%, #6f3944 100%)",
        "Heather Red": "linear-gradient(135deg, #cc7a7a 0%, #b04d4d 100%)",
        "Antique Cherry Red": "linear-gradient(135deg, #9a4d4d 0%, #773232 100%)",
        "Cherry Red": "#b32025",
        "Heather Cardinal": "linear-gradient(135deg, #9a5960 0%, #7b3b43 100%)",
        "Red": "#c61d23",
        "Maroon": "#6f1d2a",
        "Garnet": "#7b1e3a",
        "Cardinal": "#8f2030",

        "Pistachio": "#95bf6a",
        "Mint Green": "#a8d5ba",
        "Sage": "#9fad8f",
        "Lime": "#b7d63d",
        "Heather Military Green": "linear-gradient(135deg, #8b9076 0%, #6f755b 100%)",
        "Heather Irish Green": "linear-gradient(135deg, #63a36f 0%, #3f7c4c 100%)",
        "Kiwi": "#98c95c",
        "Military Green": "#667055",
        "Kelly Green": "#2f8f2f",
        "Jade Dome": "#3c8b7b",
        "Turf Green": "#3f7f3a",
        "Irish Green": "#009b48",
        "Forest Green": "#1f6a3a",
        "Fan Marine Green": "#1f7666",

        "Sky": "#b9e4f7",
        "Light Blue": "#b8dff5",
        "Iris": "#356498",
        "Carolina Blue": "#7fb8de",
        "Stone Blue": "#6c8798",
        "Antique Sapphire": "linear-gradient(135deg, #5c7aa5 0%, #3f5d87 100%)",
        "Heather Indigo": "linear-gradient(135deg, #7d8ca3 0%, #56657f 100%)",
        "Sapphire": "#1464b3",
        "Indigo": "#35536d",
        "Heather Galapagos Blue": "linear-gradient(135deg, #68899b 0%, #4a6778 100%)",
        "Neon Blue": "#25a7ff",
        "Metro Blue": "#3d73a8",
        "Heather Sapphire": "linear-gradient(135deg, #77a8c4 0%, #4f84a1 100%)",
        "Tropical Blue": "#00a6d6",
        "Heather Royal": "linear-gradient(135deg, #6f8fd1 0%, #4a6eb3 100%)",
        "Royal": "#2957d1",
        "Fan Deep Royal": "#2348a6",
        "Navy": "#1b2f5b",
        "Heather Navy": "linear-gradient(135deg, #63708f 0%, #454f69 100%)",
        "Paragon": "#27657f",

        "Heather Berry": "linear-gradient(135deg, #b27aa0 0%, #8e567d 100%)",
        "Heather Radiant Orchid": "linear-gradient(135deg, #b78acc 0%, #9167a8 100%)",
        "Heather Purple": "linear-gradient(135deg, #8f73b1 0%, #6e5590 100%)",
        "Purple": "#5d2d86",
        "Sand": "#d7c29a",
        "Dark Chocolate": "#4b3328",

        "Ash": "#d9d9d9",
        "Safety Orange": "linear-gradient(135deg, #ff8c1a 0%, #d96a00 100%)",
        "Cardinal Red": "#8f2030",
        "Safety Green": "linear-gradient(135deg, #c7df3a 0%, #9fbc1f 100%)",
        "Indigo Blue": "#4f6f8f",

        // --- PINKS / REDS ---
        "Safety Pink": "linear-gradient(135deg, #ff9ecb 0%, #ff6fa8 100%)",
        "Cardinal Red": "#8f2030",
        "Heather Sport Scarlet Red": "linear-gradient(135deg, #d94b4b 0%, #a61e1e 100%)",
        "Cherry Red": "#b32025",
        "Heather Sport Dark Maroon": "linear-gradient(135deg, #7a3a3f 0%, #4f1f24 100%)",

        // --- GREENS ---
        "High Viz Safety Green": "linear-gradient(135deg, #e6ff3f 0%, #b7d63d 100%)",
        "Military": "#667055", // matches your Military Green tone
        "Heather Sport Dark Green": "linear-gradient(135deg, #5f7a52 0%, #3e5234 100%)",
        "Fan Dark Green": "#2e5a3a",

        // --- BLUES ---
        "Sapphire": "#1464b3",
        "Indigo Blue": "#4f6f8f",
        "Neon Blue": "#25a7ff",
        "Heather Deep Royal": "linear-gradient(135deg, #4a6eb3 0%, #2f4f9e 100%)",
        "Fan Deep Royal": "#2348a6",

        // --- GRAYS / SPECIAL ---
        "Fan Heather Charcoal": "linear-gradient(135deg, #5a5a5a 0%, #2f2f2f 100%)",

        // --- GREYS ---
        "Ash Grey": "#d9d9d9",
        "Ring Spun Sport Gray": "linear-gradient(135deg, #d8d8d8 0%, #b5b5b5 100%)",
        "Cement": "#cfcac2",
        "Smoke": "#7a7a7a",
        "Heather Black": "linear-gradient(135deg, #3a3a3a 0%, #111111 100%)",

        // --- YELLOWS / ORANGES ---
        "Yellow Haze": "#f4e88a",
        "Mustard": "#c49a1a",
        "Dusty Rose": "#c98c8c",
        "Tangerine": "#f28c28",
        "Texas Orange": "#d95f02",

        // --- PINKS ---
        "Pink Lemonade": "#ff9ecb",

        // --- GREENS ---
        "Pistachio": "#95bf6a",
        "Sage": "#9fad8f",
        "Aquatic": "#6ec6c3",

        // --- BLUES ---
        "Stone Blue": "#6c8798",
        "Cobalt": "#2f5fa4",
        "Blue Dusk": "#4f6f8f",
        "Paragon": "#27657f",

        // --- BROWNS ---
        "Brown Savana": "#8a6a4a",
        "Cocoa": "#6b4f3a",
        "Vintage Black": "#2b2b2b",
        "Athletic Heather": "linear-gradient(135deg, #cfcfcf 0%, #a9a9a9 100%)",
        "Heather Dust": "#d8d1c7",
        "Soft Pink": "#f5c6d3",
        "Berry": "#a33c5a",
        "Kelly": "#1f8f4e",
        "Leaf": "#6f9e44",
        "Army": "#5f6a46",
        "Baby Blue": "#b9d9f3",
        "True Royal": "#1f57d6",
        "Midnight Navy": "#24324f",

        "Heather Prism Peach": "linear-gradient(135deg, #f6c6b8 0%, #e9a995 100%)",
        "Heather Prism Lilac": "linear-gradient(135deg, #d7c4eb 0%, #b89ed8 100%)",
        "Heather Autumn": "linear-gradient(135deg, #b86a4b 0%, #8f4f35 100%)",
        "Heather Green": "linear-gradient(135deg, #6fa074 0%, #4c7b54 100%)",
        "Heather Forest": "linear-gradient(135deg, #4f7054 0%, #35503a 100%)",
        "Heather Columbia Blue": "linear-gradient(135deg, #a8cde8 0%, #7fb1d7 100%)",
        "Heather True Royal": "linear-gradient(135deg, #5a7fe0 0%, #355fc8 100%)",
        "Heather Purple": "linear-gradient(135deg, #8d73b8 0%, #6a5695 100%)",
        "Heather Deep Teal": "linear-gradient(135deg, #2d7c80 0%, #1f5d60 100%)",
        "Heather Slate": "linear-gradient(135deg, #6f7f8d 0%, #4e5d69 100%)",
        "Heather Prism Ice Blue": "linear-gradient(135deg, #d7edf7 0%, #b9dceb 100%)",
        "Heather Prism Dusty Blue": "linear-gradient(135deg, #b7c8d8 0%, #8fa5ba 100%)",
        "Heather Prism Mint": "linear-gradient(135deg, #d5efe4 0%, #b7dccd 100%)",
        "Heather Prism Natural": "linear-gradient(135deg, #efe3d2 0%, #d8c7b1 100%)",
        "Vintage White": "#f5f1e8",
        "Silver": "#cfcfcf",
        "Athletic Heather": "linear-gradient(135deg, #d7d7d7 0%, #b8b8b8 100%)",
        "Storm": "#5f6771",
        "Dark Gray": "#4f4f52",
        "Asphalt": "#52565c",
        "Slate": "#667281",

        "Yellow": "#f2d84b",
        "Maize Yellow": "#e1c044",
        "Sunset": "#f2a06b",
        "Peach": "#f5b08a",
        "Heather Peach": "linear-gradient(135deg, #f4c2ad 0%, #de9f86 100%)",
        "Terracotta": "#c7775c",
        "Coral": "#f08c78",
        "Autumn": "#b76543",
        "Burnt Orange": "#b85a2b",

        "Lilac": "#c9b7ea",
        "Pink": "#f3a7c4",
        "Orchid": "#b87cc3",
        "Charity Pink": "#f07db3",
        "Fuchsia": "#c63d8c",
        "Mauve": "#b78493",
        "Heather Prism Peach": "linear-gradient(135deg, #f6c9bb 0%, #e5a58f 100%)",
        "Heather Prism Lilac": "linear-gradient(135deg, #d9c8ee 0%, #baa4de 100%)",

        "Vintage Red": "#b4524f",
        "Poppy": "#c74343",
        "Canvas Red": "#b62f32",
        "Cardinal": "#8f2030",
        "Rust": "#9a543c",
        "Maroon": "#6f1d2a",
        "Oxblood": "#5a1f27",
        "Heather Maroon": "linear-gradient(135deg, #8b5a64 0%, #6f3944 100%)",

        "Citron": "#9bbf3f",
        "Spring Green": "#54b85b",
        "Thyme": "#6f7e55",
        "Army": "#5f6a46",
        "Pine": "#3f5a46",
        "Teal": "#237b7b",
        "Olive": "#6d6b42",
        "Leaf": "#6e9b43",
        "Kelly": "#24a04a",
        "Forest": "#2e5a3a",

        "Atlantic": "#3c6d73",
        "Vintage Denim": "#5f7890",
        "Dusty Blue": "#7fa1b8",
        "Ocean Blue": "#3b89b6",
        "Aqua": "#55bfc6",
        "Columbia Blue": "#9fd0ec",
        "Steel Blue": "#5b7d95",
        "Turquoise": "#3dbcc3",
        "Electric Blue": "#2e8fe6",
        "Deep Teal": "#1f6d70",
        "Marine": "#2e5f7a",
        "Cool Blue": "#5f8ea8",
        "True Royal": "#2b5ed9",

        "Lavender Dust": "#c5bdd8",
        "Dark Lavender": "#8f7aa8",
        "Light Violet": "#b9a2d8",
        "Royal Purple": "#6d4aa6",
        "Purple Storm": "#6f5d86",
        "Team Purple": "#5f3d8a",

        "Soft Cream": "#efe3cf",
        "Sand Dune": "#cdbba2",
        "Tan": "#b99674",
        "Chestnut": "#8a6248",
        "Toast": "#b58763",
        "Clay": "#b6795f",
        "Pebble": "#9d8d83",
        "Vintage Brown": "#7a5a4a",
        "Brown": "#6b4a36",

        "Heather Cement": "linear-gradient(135deg, #d3cec7 0%, #b9b3ac 100%)",
        "Heather Natural": "linear-gradient(135deg, #efe4d3 0%, #d8c7ad 100%)",
        "Heather Oatmeal": "linear-gradient(135deg, #d9cfbd 0%, #b9ae97 100%)",
        "Heather Prism Natural": "linear-gradient(135deg, #efe3d2 0%, #d8c7b1 100%)",
        "Heather Cool Gray": "linear-gradient(135deg, #cfd3d8 0%, #a9b0b7 100%)",
        "Heather Silver": "linear-gradient(135deg, #d6d6d6 0%, #b6b6b6 100%)",
        "Heather Athletic": "linear-gradient(135deg, #d4d4d4 0%, #b0b0b0 100%)",
        "Heather Storm": "linear-gradient(135deg, #7a8490 0%, #58616b 100%)",
        "Heather Deep": "linear-gradient(135deg, #54585f 0%, #383c42 100%)",
        "Heather Dark Gray": "linear-gradient(135deg, #6b6b6f 0%, #4c4c50 100%)",
        "Heather Yellow Gold": "linear-gradient(135deg, #d7b44a 0%, #b58c1f 100%)",
        "Heather French Vanilla": "linear-gradient(135deg, #f1e2b9 0%, #dac48a 100%)",
        "Heather Yellow": "linear-gradient(135deg, #f0dc67 0%, #d4bd3a 100%)",
        "Heather Marmalade": "linear-gradient(135deg, #e5985b 0%, #c56d2f 100%)",
        "Heather Gold": "linear-gradient(135deg, #d3b14a 0%, #af8a23 100%)",
        "Heather Mustard": "linear-gradient(135deg, #caa13d 0%, #a57e19 100%)",
        "Neon Yellow": "#e7ff3f",
        "Heather Sunset": "linear-gradient(135deg, #e9a07f 0%, #cb7550 100%)",
        "Heather Prism Sunset": "linear-gradient(135deg, #f1b09a 0%, #d88970 100%)",
        "Heather Clay": "linear-gradient(135deg, #c88c74 0%, #a8674f 100%)",
        "Neon Orange": "#ff7a1a",
        "Heather Bubble Gum": "linear-gradient(135deg, #f4a8c9 0%, #df77a7 100%)",
        "Heather Raspberry": "linear-gradient(135deg, #b85b7f 0%, #94415f 100%)",
        "Heather Charity Pink": "linear-gradient(135deg, #ef9cc0 0%, #d870a0 100%)",
        "Neon Pink": "#ff5fb2",
        "Heather Pink": "linear-gradient(135deg, #efb1c7 0%, #d78ea8 100%)",
        "Heather Orchid": "linear-gradient(135deg, #b689c3 0%, #91679f 100%)",
        "Heather Pink Gravel": "linear-gradient(135deg, #b79aa4 0%, #90767f 100%)",
        "Heather Magenta": "linear-gradient(135deg, #b85a9a 0%, #8f4175 100%)",
        "Solid Red Blend": "#c73b3f",
        "Heather Canvas Red": "linear-gradient(135deg, #b95a5a 0%, #913838 100%)",
        "Heather Stone": "linear-gradient(135deg, #c7b8ab 0%, #a9988c 100%)",
        "Heather Prism Mint": "linear-gradient(135deg, #d6eee2 0%, #b4d8c9 100%)",
        "Heather Sea Green": "linear-gradient(135deg, #7db2a0 0%, #5b8d7d 100%)",
        "Heather Grass Green": "linear-gradient(135deg, #6ba35d 0%, #4b7e40 100%)",
        "Heather Olive": "linear-gradient(135deg, #7a7b58 0%, #5b5c40 100%)",
        "Heather Emerald": "linear-gradient(135deg, #3d8d6b 0%, #2b6a50 100%)",
        "Heather Ice Blue": "linear-gradient(135deg, #d7edf4 0%, #b8d8e6 100%)",
        "Heather Prism Ice Blue": "linear-gradient(135deg, #d8eef7 0%, #b7daeb 100%)",
        "Heather Blue": "linear-gradient(135deg, #6d93b0 0%, #4d708b 100%)",
        "Heather Baby Blue": "linear-gradient(135deg, #bdd8ea 0%, #98bfd8 100%)",
        "Heather Dusty Blue": "linear-gradient(135deg, #a8bfd0 0%, #7e99ad 100%)",
        "Heather Prism Blue": "linear-gradient(135deg, #b7d4e8 0%, #8fb6d0 100%)",
        "Heather Prism Dusty Blue": "linear-gradient(135deg, #b9cad7 0%, #8fa6b9 100%)",
        "Heather Carolina Blue": "linear-gradient(135deg, #94c1df 0%, #6fa4ca 100%)",
        "Heather Aqua": "linear-gradient(135deg, #7ecfd1 0%, #55afb2 100%)",
        "Heather Blue Lagoon": "linear-gradient(135deg, #4ca0ad 0%, #327785 100%)",
        "Heather Blue Storm": "linear-gradient(135deg, #6b8596 0%, #4d6474 100%)",
        "Neon Blue": "#25a7ff",
        "Solid True Royal Blend": "#3566da",
        "Heather Midnight Navy": "linear-gradient(135deg, #4f5d7a 0%, #35415c 100%)",
        "Solid Navy Blend": "#2f466d",
        "Heather Team Purple": "linear-gradient(135deg, #7a63a8 0%, #5a4586 100%)",
        "Heather Dark Lvnder": "linear-gradient(135deg, #8f84ab 0%, #6d6489 100%)",
        "Heather Lapis": "linear-gradient(135deg, #5b73c7 0%, #3f58a5 100%)",
        "Heather Sand Dune": "linear-gradient(135deg, #cbbca7 0%, #b09c83 100%)",
        "Heather Tan": "linear-gradient(135deg, #c6a888 0%, #a88662 100%)",
        "Heather Brown": "linear-gradient(135deg, #8f6d58 0%, #6c4e3d 100%)",
        "Heather Soft Cream": "linear-gradient(135deg, #efe4d1 0%, #d9cab0 100%)",
        "Heather Mauve": "linear-gradient(135deg, #b78493 0%, #8e626f 100%)",
        "Mint": "#a8e6cf",
        "Heather Mint": "linear-gradient(135deg, #c9f1e2 0%, #9fd8c4 100%)",
        "Heather Sage": "linear-gradient(135deg, #a8b8a2 0%, #7f8f79 100%)",
        "Heather Kelly": "linear-gradient(135deg, #4caf6a 0%, #2f7f48 100%)",
        "Heather Athletic": "linear-gradient(135deg, #d4d4d4 0%, #b0b0b0 100%)",
        "Mustard": "#c49a1a",
        "Military Green": "#667055",
        "Storm": "#5f6771",
        "Dark Gray": "#4f4f52",
        "Asphalt": "#52565c",

        "Charcoal Black Slub": "linear-gradient(135deg, #4a4a4a 0%, #2a2a2a 100%)",
        "Solid Black Slub": "linear-gradient(135deg, #3a3a3a 0%, #1a1a1a 100%)",

        "Canvas Red": "#b62f32",
        "Citron": "#9bbf3f",
        "Strobe": "#d9f07a",

        "Forest": "#2e5a3a",

        "Vintage Navy": "#2c3e5f",

        "Blue Storm": "#5b7284",
        "Atlantic": "#3c6d73",

        "Light Violet": "#b9a2d8",
        "Lavender Blue": "#a9b6e5",

        "Sand Dune": "#cdbba2",
        "Terracotta": "#c7775c",
        "Chestnut": "#8a6248",
        "Toast": "#b58763",
        "Vintage Brown": "#7a5a4a",
        "Solid White Blend": "#f5f5f5",

        "Heather Natural": "linear-gradient(135deg, #efe4d3 0%, #d8c7ad 100%)",
        "Heather Athletic": "linear-gradient(135deg, #d4d4d4 0%, #b0b0b0 100%)",
        "Heather Dark Gray": "linear-gradient(135deg, #6b6b6f 0%, #4c4c50 100%)",
        "Heather Deep": "linear-gradient(135deg, #54585f 0%, #383c42 100%)",
        "Solid Black Blend": "#1f1f1f",

        "Heather French Vanilla": "linear-gradient(135deg, #f1e2b9 0%, #dac48a 100%)",
        "Heather Mustard": "linear-gradient(135deg, #caa13d 0%, #a57e19 100%)",
        "Heather Yellow Gold": "linear-gradient(135deg, #d7b44a 0%, #b58c1f 100%)",
        "Heather Pink Gravel": "linear-gradient(135deg, #b79aa4 0%, #90767f 100%)",
        "Heather Clay": "linear-gradient(135deg, #c88c74 0%, #a8674f 100%)",
        "Heather Stone": "linear-gradient(135deg, #c7b8ab 0%, #a9988c 100%)",
        "Heather Olive": "linear-gradient(135deg, #7a7b58 0%, #5b5c40 100%)",
        "Heather Carolina Blue": "linear-gradient(135deg, #94c1df 0%, #6fa4ca 100%)",
        "Heather Dusty Blue": "linear-gradient(135deg, #a8bfd0 0%, #7e99ad 100%)",
        "Heather Midnight Navy": "linear-gradient(135deg, #4f5d7a 0%, #35415c 100%)",
        "Heather Dark Lavnder": "linear-gradient(135deg, #8f84ab 0%, #6d6489 100%)",
        "Heather Brown": "linear-gradient(135deg, #8f6d58 0%, #6c4e3d 100%)",
        "Solid White Triblend": "#f3f3f3",
        "Oatmeal Triblend": "linear-gradient(135deg, #e8dcc7 0%, #d2c2a8 100%)",
        "Athletic Gray Triblend": "linear-gradient(135deg, #cfcfcf 0%, #a8a8a8 100%)",
        "Gray Triblend": "linear-gradient(135deg, #bdbdbd 0%, #8e8e8e 100%)",
        "Solid Dark Gray Triblend": "#555555",
        "Charcoal Black Triblend": "linear-gradient(135deg, #3a3a3a 0%, #1f1f1f 100%)",
        "Solid Black Triblend": "#121212",
        "Heather Black Triblend": "linear-gradient(135deg, #3c3c3c 0%, #1a1a1a 100%)",
        "Mauve Triblend": "linear-gradient(135deg, #b78493 0%, #8e626f 100%)",
        "Brick Triblend": "#a14a3f",
        "Red Triblend": "#c73b3f",
        "Maroon Triblend": "#6f1d2a",
        "Olive Triblend": "#6d6b42",
        "Emerald Triblend": "#2f8f6b",
        "Blue Triblend": "#4f84b5",
        "Denim Triblend": "#5f7890",
        "True Royal Triblend": "#2b5ed9",
        "Navy Triblend": "#1b2f5b",
        "Solid Navy Triblend": "#2f466d",
        "Gray Acid Fleece": "linear-gradient(135deg, #d1d1d1 0%, #a9a9a9 100%)",

        "Gray Triblend": "linear-gradient(135deg, #c7c7c7 0%, #9e9e9e 100%)",
        "Silver": "#cfcfcf",
        "Asphalt": "#52565c",
        "Vintage Black": "#2b2b2b",
        "Mauve": "#b78493",
        "Pink": "#f3a7c4",
        "Cardinal": "#8f2030",
        "Heather Forest": "linear-gradient(135deg, #4e6b52 0%, #324635 100%)",
        "Forest": "#2e5a3a",
        "Heather Olive": "linear-gradient(135deg, #7a7b58 0%, #5b5c40 100%)",
        "Military Green": "#667055",
        "Lavender Blue": "#a9b6e5",
        "Blue Storm": "#5b7284",
        "Carolina Blue": "#7fb3d5",
        "True Royal": "#2b5ed9",
        "Team Purple": "#5f3d8a",
        "Heather Athletic": "linear-gradient(135deg, #d4d4d4 0%, #b0b0b0 100%)",
        "Heather Deep": "linear-gradient(135deg, #54585f 0%, #383c42 100%)",
        "Heather Dark Gray": "linear-gradient(135deg, #6b6b6f 0%, #4c4c50 100%)",
        "Heather Black": "linear-gradient(135deg, #3c3c3c 0%, #171717 100%)",
        "Heather Mustard": "linear-gradient(135deg, #caa13d 0%, #a57e19 100%)",
        "Heather Red": "linear-gradient(135deg, #b95a5a 0%, #913838 100%)",
        "Heather Deep Teal": "linear-gradient(135deg, #1f6d70 0%, #13494c 100%)",
        "Heather Blue Lagoon": "linear-gradient(135deg, #4ca0ad 0%, #327785 100%)",
        "Heather True Royal": "linear-gradient(135deg, #5a7be0 0%, #2f52c4 100%)",
        "Heather Navy": "linear-gradient(135deg, #3e4f7a 0%, #263457 100%)",
        "Gray Acid Fleece": "linear-gradient(135deg, #d7d7d7 0%, #a8a8a8 100%)",
        "Heather Athletic": "linear-gradient(135deg, #d4d4d4 0%, #b0b0b0 100%)",
        "Heather Deep": "linear-gradient(135deg, #54585f 0%, #383c42 100%)",
        "Heather Dark Gray": "linear-gradient(135deg, #6b6b6f 0%, #4c4c50 100%)",
        "Asphalt": "#52565c",
        "Vintage Black": "#2b2b2b",
        "Heather Dust": "linear-gradient(135deg, #d8d1c7 0%, #bfb6aa 100%)",
        "Heather Mustard": "linear-gradient(135deg, #caa13d 0%, #a57e19 100%)",
        "Heather Charity Pink": "linear-gradient(135deg, #ef9cc0 0%, #d870a0 100%)",
        "Mauve": "#b78493",
        "Pink": "#f3a7c4",
        "Heather Red": "linear-gradient(135deg, #b95a5a 0%, #913838 100%)",
        "Heather Maroon": "linear-gradient(135deg, #8b5a64 0%, #6f3944 100%)",
        "Cardinal": "#8f2030",
        "Teal": "#237b7b",
        "Heather Forest": "linear-gradient(135deg, #4e6b52 0%, #324635 100%)",
        "Forest": "#2e5a3a",
        "Heather Olive": "linear-gradient(135deg, #7a7b58 0%, #5b5c40 100%)",
        "Lavender Blue": "#a9b6e5",
        "Dusty Blue": "#7fa1b8",
        "Heather Blue Lagoon": "linear-gradient(135deg, #4ca0ad 0%, #327785 100%)",
        "Blue Storm": "#5b7284",
        "Heather Deep Teal": "linear-gradient(135deg, #1f6d70 0%, #13494c 100%)",
        "Heather Slate": "linear-gradient(135deg, #6f7f8d 0%, #4e5d69 100%)",
        "Atlantic": "#3c6d73",
        "Heather Columbia Blue": "linear-gradient(135deg, #a8cde8 0%, #7fb1d7 100%)",
        "Steel Blue": "#5b7d95",
        "Heather True Royal": "linear-gradient(135deg, #5a7be0 0%, #2f52c4 100%)",
        "True Royal": "#2b5ed9",
        "Heather Navy": "linear-gradient(135deg, #3e4f7a 0%, #263457 100%)",
        "Team Purple": "#5f3d8a",
        "Heather Team Purple": "linear-gradient(135deg, #7a63a8 0%, #5a4586 100%)",
        "Vintage Brown": "#7a5a4a",
        // "Light Gray Marble": "linear-gradient(135deg, #e3e3e3 0%, #cfcfcf 100%)",
        // "Digital Gray": "#8d8d8d",
        // "Dark Gray Marble Fleck": "linear-gradient(135deg, #5a5a5a 0%, #2f2f2f 100%)",
        // "Heather Dark Gray / Black": "linear-gradient(135deg, #6b6b6f 0%, #171717 100%)",
        // "French Vanilla": "#f3e5ab",
        // "Yellow": "#f2d84b",
        // "Strobe": "#d9f07a",
        // "Gold": "#d4af37",
        // "Peach": "#f5b08a",
        // "Autumn": "#b76543",
        // "Heather Mauve": "linear-gradient(135deg, #b78493 0%, #8e626f 100%)",
        // "Poppy": "#c74343",
        // "Red Marble Fleck": "linear-gradient(135deg, #c94b4b 0%, #7a2a2a 100%)",
        // "Lilac": "#c9b7ea",
        // "Heather Sand Dune": "linear-gradient(135deg, #cbbca7 0%, #b09c83 100%)",
        // =========================
        // COMFORT COLORS / COLOR BLAST
        // =========================

        // --- CC1745 / Color Blast ---
        "Smoke": "linear-gradient(135deg, #7a7a7a 0%, #4b4b4b 45%, #a1a1a1 100%)",
        "Citrine": "linear-gradient(135deg, #d6c64a 0%, #9c8f2a 45%, #f0e27a 100%)",
        "Umber": "linear-gradient(135deg, #7d5236 0%, #4b2f20 45%, #a77352 100%)",
        "Hibiscus": "linear-gradient(135deg, #c85772 0%, #8d3650 45%, #ef8ba0 100%)",
        "Clay": "linear-gradient(135deg, #b97b61 0%, #7d5441 45%, #d6a08b 100%)",
        "Sea Glass": "linear-gradient(135deg, #84cabc 0%, #4d9386 45%, #b8e7de 100%)",
        "Fern": "linear-gradient(135deg, #647f51 0%, #3e5634 45%, #86aa71 100%)",
        "Fiji Blue": "linear-gradient(135deg, #4690b6 0%, #255f82 45%, #7ac9e6 100%)",
        "Ocean": "linear-gradient(135deg, #356f91 0%, #1d4257 45%, #5ca8cb 100%)",
        "Amethyst": "linear-gradient(135deg, #8f6db8 0%, #5a437c 45%, #c0a5e6 100%)",

        // --- CC core neutrals ---
        "Granite": "#8b8e90",
        "Graphite": "#5f6368",
        "Pepper": "#5a5550",
        "Sandstone": "#ccb79c",
        "Khaki": "#bca37f",
        "Ivory": "#f0ead9",

        // --- CC yellows / oranges ---
        "Butter": "#f1de8c",
        "Neon Lemon": "#e9ff43",
        "Citrus": "#d8c54a",
        "Mustard": "#c49a1a",
        "Peachy": "#f1b190",
        "Neon Red Orange": "#ff6138",
        "Neon Cantaloupe": "#ff9f69",
        "Bright Salmon": "#f48f7d",
        "Terracotta": "#c7775c",
        "Melon": "#f2a07d",
        "Bright Orange": "#ff7a00",
        "Burnt Orange": "#b85a2b",
        "Mango": "#f0a03c",
        "Yam": "#c96b3d",

        // --- CC pinks / reds ---
        "Blossom": "#f2b8c6",
        "Neon Pink": "#ff5fb2",
        "Crunchberry": "#c95b79",
        "Watermelon": "#f06f7d",
        "Red": "#c61d23",
        "Paprika": "#b24b35",
        "Crimson": "#9e3047",
        "Berry": "#a33c5a",
        "Chili": "#8f3a32",
        "Brick": "#a14a3f",
        "Wine": "#6d2f4f",
        "Rose Quartz": "#d8b7c8",

        // --- CC greens ---
        "Island Reef": "#59b8a6",
        "Bay": "#5f8b7c",
        "Chalky Mint": "#bddcca",
        "Moss": "#6d7554",
        "Seafoam": "#bdd8c7",
        "Island Green": "#4f8b73",
        "Sage": "#9fad8f",
        "Blue Spruce": "#59706a",
        "Light Green": "#b7cf8a",
        "Hemp": "#9b8962",
        "Emerald": "#2f8f6b",
        "Celedon": "#a8c7a2",
        "Kiwi": "#98c95c",
        "Lime": "#b7d63d",
        "Grass": "#6ea24f",
        "Clover": "#4d8a57",

        // --- CC blues ---
        "Washed Denim": "#7189a1",
        "Denim": "#5f7890",
        "Chambray": "#8ba8bf",
        "Hydrangea": "#8ea9d8",
        "Lagoon Blue": "#3f8fa9",
        "Flo Blue": "#7298b6",
        "Sapphire": "#1464b3",
        "Mystic Blue": "#607ea8",
        "Ice Blue": "#cbe5f2",
        "Periwinkle": "#9da9d8",
        "Blue Jean": "#4f6f8f",
        "China Blue": "#6d88b3",
        "Midnight": "#30405b",
        "Royal Caribe": "#2f80a8",
        "Dusk": "#6f7b8c",
        "True Navy": "#1b2f5b",
        "Navy": "#1b2f5b",
        "Topaz Blue": "#4e8eb3",

        // --- CC purples / browns ---
        "Orchid": "#b87cc3",
        "Neon Violet": "#9b5cff",
        "Violet": "#7d5ba6",
        "Grape": "#6f4a8e",
        "Espresso": "#4b3328",
        "Chocolate": "#5a3a2a",
        "Boysenberry": "#6b4169",

        // Bella toddler / Rabbit Skins toddler missing swatches
        "Heather Stone": "linear-gradient(135deg, #c7b8ab 0%, #a9988c 100%)",
        "Heather Athletic": "linear-gradient(135deg, #d4d4d4 0%, #b0b0b0 100%)",
        "Heather Deep": "linear-gradient(135deg, #54585f 0%, #383c42 100%)",
        "Heather Dark Gray": "linear-gradient(135deg, #6b6b6f 0%, #4c4c50 100%)",
        "Solid Black Blend": "#1f1f1f",
        "Solid Athletic Gray": "#c9c9c9",
        "Heather Yellow Gold": "linear-gradient(135deg, #d7b44a 0%, #b58c1f 100%)",
        "Heather Deep Teal": "linear-gradient(135deg, #1f6d70 0%, #13494c 100%)",
        "Olive ( Olive )": "#6d6b42",
        "Heather Team Purple": "linear-gradient(135deg, #7a63a8 0%, #5a4586 100%)",
        "Team Purple": "#5f3d8a",

        "Natural Heather": "linear-gradient(135deg, #e8dcc7 0%, #d2c2a8 100%)",
        "Heather": "linear-gradient(135deg, #cfcfcf 0%, #a8a8a8 100%)",
        "Granite Heather": "linear-gradient(135deg, #8b8e90 0%, #6c7074 100%)",
        "Mauvelous": "#c08aa1",
        "Saltwater": "#8fcfd1",
        "Chill": "#86b0a8",
        "Lavender": "#b6a3d6",
        "Coyote Brown": "#8a6b4f",

        "Vintage Smoke": "#7a7670",
        "Storm Camo": "linear-gradient(135deg, #5f6771 0%, #7a7f62 50%, #3f463f 100%)",
        "Black Leopard": "linear-gradient(135deg, #111111 0%, #3b2f24 45%, #111111 100%)",
        "BAMBOO BLACKOUT": "linear-gradient(135deg, #1c1f1f 0%, #2f3b36 50%, #111111 100%)",
        "Raspberry": "#b84f7a",
        "Vintage Hot Pink": "#d96a98",
        "Vintage Camo": "linear-gradient(135deg, #7a7f62 0%, #5d6248 50%, #3f463f 100%)",
        "Turquoise": "#41b6c4",
        "Vintage Royal": "#5a73b8",
        "BERMUDA BLACKOUT": "linear-gradient(135deg, #16394a 0%, #2d6b78 50%, #111111 100%)",
        "RS Sport Grey": "linear-gradient(135deg, #d8d8d8 0%, #b5b5b5 100%)",

        "Heather Orange": "linear-gradient(135deg, #ff9a3d 0%, #cc6b1f 100%)",
        "Heather Military Green": "linear-gradient(135deg, #7a845f 0%, #56613f 100%)",
        "Heather Purple": "linear-gradient(135deg, #8b6bb3 0%, #5a3f7a 100%)",
        "Heather Galapagos Blue": "linear-gradient(135deg, #3f7f9a 0%, #29586e 100%)",

        "Heather Red": "linear-gradient(135deg, #b95a5a 0%, #913838 100%)",
        "Heather Irish Green": "linear-gradient(135deg, #4f8f4f 0%, #2f6a2f 100%)",
        "Heather Royal": "linear-gradient(135deg, #5a7be0 0%, #2f52c4 100%)",
        "Heather Navy": "linear-gradient(135deg, #3e4f7a 0%, #263457 100%)",

        "Fan Charcoal Heather": "linear-gradient(135deg, #5a5a5a 0%, #2f2f2f 100%)",
        "Fan Dark Green": "#2e5a3a",

        "Indigo Blue": "#3f5f7a",
        "Sapphire": "#1464b3",
        "Heliconia": "#d94b8a",
        "Safety Pink": "linear-gradient(135deg, #ff9ecb 0%, #ff6fa8 100%)"
      };
  
      function injectSparkles() {
        if (builder.querySelector(".bcs-builder-sparkles")) return;
  
        const wrap = document.createElement("div");
        wrap.className = "bcs-builder-sparkles";
        wrap.setAttribute("aria-hidden", "true");
  
        for (let i = 0; i < 12; i += 1) {
          const dot = document.createElement("span");
          dot.className = "bcs-builder-sparkle";
          dot.style.left = `${Math.random() * 100}%`;
          dot.style.top = `${Math.random() * 100}%`;
          dot.style.animationDelay = `${(Math.random() * 2).toFixed(2)}s`;
          dot.style.animationDuration = `${(2 + Math.random() * 2).toFixed(2)}s`;
          wrap.appendChild(dot);
        }
  
        if (!builder.style.position) {
          builder.style.position = "relative";
        }
  
        builder.appendChild(wrap);
      }
  
      function getAgreementElements() {
        const form =
          builder.closest("form") ||
          builder.closest("product-form") ||
          builder.querySelector("form") ||
          document.querySelector("form[action*='/cart/add']");
  
        const agreement =
          builder.querySelector("#bcs-agreement") ||
          builder.querySelector("input[name='agreement']") ||
          builder.querySelector("input[name='properties[_Agreement]']") ||
          builder.querySelector(".bcs-agreement-checkbox") ||
          builder.querySelector('input[type="checkbox"]');
  
        const addBtn =
          form?.querySelector('button[name="add"]') ||
          form?.querySelector(".product-form__submit") ||
          form?.querySelector('button[type="submit"]') ||
          document.querySelector('button[name="add"]') ||
          document.querySelector(".product-form__submit") ||
          document.querySelector('button[type="submit"]');
  
        return { form, agreement, addBtn };
      }
  
      function updateAgreementState() {
        const { agreement, addBtn } = getAgreementElements();
        if (!agreement || !addBtn) return;
  
        const checked = agreement.checked;
        addBtn.disabled = !checked;
        addBtn.classList.toggle("is-disabled", !checked);
        addBtn.setAttribute("aria-disabled", String(!checked));
  
        builder.classList.toggle("bcs-agreement-approved", checked);
      }
  
      function removeAgreementError() {
        builder.querySelector(".bcs-agreement-error")?.remove();
      }
  
      function showAgreementError(agreement) {
        if (builder.querySelector(".bcs-agreement-error")) return;
  
        const msg = document.createElement("p");
        msg.className = "bcs-agreement-error";
        msg.textContent = "Please agree to the made-to-order terms before adding to cart.";
  
        const mount =
          agreement.closest(".bcs-agreement-box") ||
          agreement.closest("label") ||
          agreement.parentElement;
  
        mount?.appendChild(msg);
      }
  
      function blockSubmitIfNoAgreement(event) {
        const { agreement } = getAgreementElements();
        if (!agreement || agreement.checked) return;
  
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation?.();
  
        showAgreementError(agreement);
        agreement.focus();
      }
  
      function initAgreementGuard() {
        const { form, agreement, addBtn } = getAgreementElements();
        if (!agreement || !addBtn) return;
  
        if (!builder.__bcsAgreementBound) {
          agreement.addEventListener("change", () => {
            if (agreement.checked) {
              removeAgreementError();
            }
            updateAgreementState();
          });
  
          agreement.addEventListener("input", updateAgreementState);
  
          addBtn.addEventListener("click", blockSubmitIfNoAgreement);
          form?.addEventListener("submit", blockSubmitIfNoAgreement);
  
          builder.__bcsAgreementBound = true;
        }
  
        updateAgreementState();
      }
  
      function isAllAgesMode() {
        return builder.__BCS_MODE__ === "allages";
      }
  
      function shouldHideBrandStep(cut) {
        return cut === "Youth" || cut === "Toddler";
      }
  
      function getTargets() {
        return {
          cutGroup: builder.querySelector("[data-option='cut']")?.closest(".bcs-option-group"),
          cut: builder.querySelector("[data-option='cut']"),
  
          brandGroup: builder.querySelector("[data-option='brand']")?.closest(".bcs-option-group"),
          brand: builder.querySelector("[data-option='brand']"),
  
          style: builder.querySelector("[data-option='style']"),
          color: builder.querySelector("[data-option='color']"),
          size: builder.querySelector("[data-option='size']"),
  
          brandInput: builder.querySelector("input[name='properties[_Brand Code]']"),
          colorInput: builder.querySelector("input[name='properties[Color]']"),
          sizeInput: builder.querySelector("input[name='properties[Size]']"),
          skuInput: builder.querySelector("input[name='properties[_Source SKU]']")
        };
      }
  
      function getState() {
        if (!builder.__bcsState) {
          builder.__bcsState = {
            cut: isAllAgesMode() ? "" : "Adult",
            brand: "",
            style: "",
            color: "",
            size: "",
            sku: ""
          };
        }
        return builder.__bcsState;
      }
  
      function mapBrandToCode(label) {
        const map = {
          "Gildan": "GL",
          "Bella Canvas": "BC",
          "Comfort Colors": "CC",
          "Rabbit Skins": "RS",
          "Tie-Dye": "TD",
          "GL": "GL",
          "BC": "BC",
          "CC": "CC",
          "RS": "RS",
          "TD": "TD"
        };
  
        return map[label] || label;
      }
  
      function getBrandLabel(code) {
        const match = brandOptions.find((b) => b.code === code);
        return match ? match.label : code;
      }
  
      function getAvailableCuts() {
        const scopedRules = builder.__BCS_RULES__ || {};
  
        if (isAllAgesMode()) {
          return ["Adult", "Youth", "Toddler"].filter((cut) => scopedRules[cut]);
        }
  
        return ["Adult"];
      }
  
      function getResolvedBrandForSelection(cut, style, currentBrand = "") {
        const scopedRules = builder.__BCS_RULES__ || {};
      
        // If brand selector is visible, trust user selection
        if (!shouldHideBrandStep(cut)) {
          return currentBrand;
        }
      
        const cutRules = scopedRules?.[cut] || {};
      
        // 🔥 Find the ACTUAL brand that supports the selected style
        for (const [brandCode, brandBlock] of Object.entries(cutRules)) {
          if (brandBlock?.[style]) {
            return getBrandLabel(brandCode);
          }
        }
      
        // fallback (should rarely happen)
        const firstBrand = Object.keys(cutRules)[0];
        return firstBrand ? getBrandLabel(firstBrand) : "";
      }
  
      function getAvailableBrands(cut) {
        const scopedRules = builder.__BCS_RULES__ || {};
        const source = isAllAgesMode() ? scopedRules?.[cut] : scopedRules;
  
        if (!source) return [];
        return Object.keys(source).map(getBrandLabel);
      }
  
      function getAvailableStyles(cut, brand) {
        const scopedRules = builder.__BCS_RULES__ || {};
        let stylesObj = null;
  
        if (isAllAgesMode()) {
          if (shouldHideBrandStep(cut)) {
            const cutRules = scopedRules?.[cut] || {};
            const merged = {};
  
            Object.values(cutRules).forEach((brandBlock) => {
              Object.entries(brandBlock || {}).forEach(([styleName, value]) => {
                if (!merged[styleName]) {
                  merged[styleName] = value;
                }
              });
            });
  
            stylesObj = merged;
          } else {
            const brandCode = mapBrandToCode(brand);
            stylesObj = scopedRules?.[cut]?.[brandCode] || null;
          }
        } else {
          const brandCode = mapBrandToCode(brand);
          stylesObj = scopedRules?.[brandCode] || null;
        }
  
        if (!stylesObj || typeof stylesObj !== "object") return [];
  
        const STYLE_ORDER = [
          "Short Sleeve",
          "Cropped Short Sleeve",
          "Long Sleeve",
          "Sweatshirt",
          "Hoodie",
          "Cropped Hoodie"
        ];
  
        return Object.keys(stylesObj).sort((a, b) => {
          const aIndex = STYLE_ORDER.indexOf(a);
          const bIndex = STYLE_ORDER.indexOf(b);
          const safeA = aIndex === -1 ? 999 : aIndex;
          const safeB = bIndex === -1 ? 999 : bIndex;
  
          return safeA - safeB || a.localeCompare(b);
        });
      }
  
      function getSkuBucket(cut, brand, style) {
        const scopedRules = builder.__BCS_RULES__ || {};
  
        if (isAllAgesMode()) {
          if (shouldHideBrandStep(cut)) {
            const cutRules = scopedRules?.[cut] || {};
  
            for (const brandBlock of Object.values(cutRules)) {
              if (brandBlock?.[style]) {
                return brandBlock[style];
              }
            }
  
            return {};
          }
  
          const brandCode = mapBrandToCode(brand);
          return scopedRules?.[cut]?.[brandCode]?.[style] || {};
        }
  
        const brandCode = mapBrandToCode(brand);
        return scopedRules?.[brandCode]?.[style] || {};
      }
  
      function getColors(cut, brand, style) {
        const bucket = getSkuBucket(cut, brand, style);
        const map = {};
  
        Object.values(bucket).forEach((data) => {
          Object.entries(data.colors || {}).forEach(([color, sizes]) => {
            if (!map[color]) {
              map[color] = {
                sizes: new Set(),
                skus: new Set()
              };
            }
  
            sizes.forEach((s) => map[color].sizes.add(s));
          });
        });
  
        return map;
      }
  
      function getSizesForColor(cut, brand, style, color) {
        const colors = getColors(cut, brand, style);
        return colors[color] ? Array.from(colors[color].sizes) : [];
      }
  
      function getPreferredSkuForColor(cut, brand, style, color) {
        const bucket = getSkuBucket(cut, brand, style);
  
        for (const sku in bucket) {
          if (bucket[sku].colors[color]) return sku;
        }
  
        return "";
      }
  
      function getSwatchBackground(name) {
        return COLOR_SWATCH_MAP[name] || "#cccccc";
      }
  
      function getProductScope() {
        return (
          builder.closest("product-info") ||
          builder.closest(".product") ||
          builder.closest(".shopify-section") ||
          document
        );
      }
  
      function getShopifySelects() {
        const selects = Array.from(
          getProductScope().querySelectorAll("variant-selects select")
        );
  
        if (selects.length < 3) return null;
  
        return {
          cutSelect: selects[0],
          brandSelect: selects[1],
          styleSelect: selects[2]
        };
      }
  
      function setNativeSelectValue(select, value) {
        if (!select) return;
  
        const nativeSetter = Object.getOwnPropertyDescriptor(
          window.HTMLSelectElement.prototype,
          "value"
        )?.set;
  
        if (nativeSetter) {
          nativeSetter.call(select, value);
        } else {
          select.value = value;
        }
  
        select.dispatchEvent(new Event("input", { bubbles: true }));
        select.dispatchEvent(new Event("change", { bubbles: true }));
      }
  
      function syncShopifyVariant(cut, brand, style) {
        const selects = getShopifySelects();
        if (!selects) return;
  
        isSyncing = true;
  
        if (selects.cutSelect && cut) {
          setNativeSelectValue(selects.cutSelect, cut);
        }
  
        setTimeout(() => {
          const fresh = getShopifySelects();
          if (!fresh) {
            isSyncing = false;
            return;
          }
  
          if (fresh.brandSelect && brand) {
            setNativeSelectValue(fresh.brandSelect, brand);
          }
  
          setTimeout(() => {
            const latest = getShopifySelects();
            if (!latest) {
              isSyncing = false;
              return;
            }
  
            if (latest.styleSelect && style) {
              setNativeSelectValue(latest.styleSelect, style);
            }
  
            isSyncing = false;
          }, 80);
        }, 80);
      }
  
      function renderButtons(target, values, active, kind) {
        if (!target) return;
  
        target.innerHTML = "";
  
        if (kind === "color") {
          target.classList.add("bcs-color-grid");
        } else {
          target.classList.remove("bcs-color-grid");
        }
  
        values.forEach((value) => {
          const btn = document.createElement("button");
          btn.type = "button";
          btn.dataset.kind = kind;
          btn.dataset.value = value;
  
          if (kind === "color") {
            btn.className = "bcs-swatch-btn";
            btn.setAttribute("aria-label", value);
            btn.title = value;
  
            const swatch = document.createElement("span");
            swatch.className = "bcs-swatch";
            swatch.style.background = getSwatchBackground(value);
  
            const label = document.createElement("span");
            label.className = "bcs-swatch-label";
            label.textContent = value;
  
            btn.appendChild(swatch);
            btn.appendChild(label);
          } else {
            btn.className = "bcs-option-btn";
            btn.textContent = value;
          }
  
          if (value === active) {
            btn.classList.add("is-active");
          }
  
          target.appendChild(btn);
        });
      }
  
      function setHiddenInputs(state, targets) {
        if (targets.brandInput) {
          const resolvedBrand = shouldHideBrandStep(state.cut)
            ? getResolvedBrandForSelection(state.cut, state.style, state.brand)
            : state.brand;
  
          targets.brandInput.value = mapBrandToCode(resolvedBrand);
        }
  
        if (targets.colorInput) targets.colorInput.value = state.color;
        if (targets.sizeInput) targets.sizeInput.value = state.size;
        if (targets.skuInput) targets.skuInput.value = state.sku;
      }
  
      function updateCompleteState(state) {
        const isComplete =
          Boolean(state.cut) &&
          Boolean(state.style) &&
          Boolean(state.color) &&
          Boolean(state.size) &&
          Boolean(state.sku);
  
        const wasComplete = builder.__bcsWasComplete === true;
  
        builder.classList.toggle("bcs-complete", isComplete);
  
        if (isComplete && !wasComplete) {
          builder.classList.remove("bcs-complete-pulse");
          void builder.offsetWidth;
          builder.classList.add("bcs-complete-pulse");
        }
  
        if (!isComplete) {
          builder.classList.remove("bcs-complete-pulse");
        }
  
        builder.__bcsWasComplete = isComplete;
      }
  
      function renderAll() {
        const targets = getTargets();
        const state = getState();
  
        const cuts = getAvailableCuts();
        if (!cuts.includes(state.cut)) {
          state.cut = cuts[0] || "";
        }
  
        if (targets.cutGroup) {
          targets.cutGroup.style.display = isAllAgesMode() ? "" : "none";
        }
  
        renderButtons(targets.cut, cuts, state.cut, "cut");
  
        const hideBrand = isAllAgesMode() && shouldHideBrandStep(state.cut);
  
        if (targets.brandGroup) {
          targets.brandGroup.style.display = hideBrand ? "none" : "";
        }
  
        const brands = getAvailableBrands(state.cut);
  
        if (hideBrand) {
          const resolved = getResolvedBrandForSelection(
            state.cut,
            state.style,
            state.brand
          );
        
          state.brand = resolved || brands[0] || "";
        
          if (targets.brand) {
            targets.brand.innerHTML = "";
          }
        } else {
          if (!brands.includes(state.brand)) {
            state.brand = brands[0] || "";
          }
  
          renderButtons(targets.brand, brands, state.brand, "brand");
        }
  
        const styles = getAvailableStyles(state.cut, state.brand);
        if (!styles.includes(state.style)) {
          state.style = styles[0] || "";
        }
  
        renderButtons(targets.style, styles, state.style, "style");
  
        const colors = Object.keys(getColors(state.cut, state.brand, state.style));
  
        if (!colors.includes(state.color)) {
          state.color = "";
          state.size = "";
          state.sku = "";
        }
  
        renderButtons(targets.color, colors, state.color, "color");
  
        const sizes = state.color
          ? getSizesForColor(state.cut, state.brand, state.style, state.color)
          : [];
  
        if (!sizes.includes(state.size)) {
          state.size = "";
        }
  
        renderButtons(targets.size, sizes, state.size, "size");
  
        if (state.color && !state.sku) {
          state.sku = getPreferredSkuForColor(
            state.cut,
            state.brand,
            state.style,
            state.color
          );
        }
  
        setHiddenInputs(state, targets);
  
        const syncBrand = hideBrand
          ? getResolvedBrandForSelection(state.cut, state.style, state.brand)
          : state.brand;
  
        if (syncBrand && state.style) {
          syncShopifyVariant(state.cut, syncBrand, state.style);
        }
  
        updateCompleteState(state);
        initAgreementGuard();
      }
  
      function handleClick(e) {
        const btn = e.target.closest(".bcs-option-btn, .bcs-swatch-btn");
        if (!btn) return;
  
        const clickedBuilder = btn.closest("[data-apparel-builder]");
        if (!clickedBuilder || clickedBuilder !== builder) return;
  
        const state = getState();
        const kind = btn.dataset.kind;
        const value = btn.dataset.value;
  
        if (kind === "cut") {
          state.cut = value;
          state.brand = "";
          state.style = "";
          state.color = "";
          state.size = "";
          state.sku = "";
          renderAll();
          return;
        }
  
        if (kind === "brand") {
          state.brand = value;
          state.style = "";
          state.color = "";
          state.size = "";
          state.sku = "";
          renderAll();
          return;
        }
  
        if (kind === "style") {
          state.style = value;
          state.color = "";
          state.size = "";
          state.sku = "";
          renderAll();
          return;
        }
  
        if (kind === "color") {
          state.color = value;
          state.size = "";
          state.sku = getPreferredSkuForColor(
            state.cut,
            state.brand,
            state.style,
            value
          );
          renderAll();
          return;
        }
  
        if (kind === "size") {
          state.size = value;
          renderAll();
        }
      }
  
      document.addEventListener("change", function (event) {
        if (isSyncing) return;
  
        const selects = getShopifySelects();
        if (!selects) return;
  
        if (
          event.target === selects.cutSelect ||
          event.target === selects.brandSelect ||
          event.target === selects.styleSelect
        ) {
          renderAll();
        }
      });
  
      builder.addEventListener("click", handleClick);
  
      injectSparkles();
      renderAll();
    }
  })();